/**
 * =============================================================================
 * Zencebyl Health Search (Detaylı Arama) — Client Orchestration
 * =============================================================================
 *
 * Sayfa: /pages/detayli-arama
 *
 * AKIŞ
 * ----
 * 1. POST {healthApiUrl}/api/v1/recommendations/search  → wellnessGoals
 * 2. renderWellnessGoals()  → ara adım kartları (#ZencebylGoalsTarget)
 * 3. Goal tıklanınca: associatedProductIds → Storefront handles → Section Rendering grid
 *    (#ZencebylResultsTarget) — native Flux card-product (koleksiyon parity)
 *
 * GOALS UI (#ZencebylGoalsTarget)
 * ------------------------------
 * data.wellnessGoals[] → hedef kartları (associatedProductIds data attribute)
 *
 * GRID YÜKLEME — SHOPIFY LİMİTLERİ
 * ---------------------------------
 * - Search API (handle:a OR handle:b): max 10 ürün → 11+ öneride kullanılmaz
 * - Liquid all_products: max ~20 handle/render → LIQUID_HANDLES_BATCH_LIMIT ile batch
 * - Eksik handle: tek tek handles URL, sonra search?handle:xxx kurtarma
 * - mergeGridHtmlParts + reorderGridByHandles → API sırası korunur
 *
 * FLUX PARİTY NOTU
 * ----------------
 * Kart HTML'i elle yazılmaz; section_id=health-search-product-grid + card-product snippet.
 */
(function () {
  'use strict';

  function initConfig() {
    var section = document.getElementById('ZencebylSearchSection');
    if (!section) return;

    window.ZencebylConfig = {
      healthApiUrl: section.dataset.healthUrl,
      healthApiKey: section.dataset.healthKey,
      storefrontToken: section.dataset.storefrontToken,
      storefrontUrl: 'https://7epv0t-d4.myshopify.com/api/2024-01/graphql.json',
      gridSectionId: section.dataset.gridSectionId || 'health-search-product-grid'
    };
  }

  var EMPTY_MESSAGE = 'Aramanızla eşleşen ürün bulunamadı.';
  var LOADING_MESSAGE = 'Öneriler yükleniyor…';

  var ERROR_MESSAGES = {
    SYSTEM_BUSY:
      'Şu anda zeka motorumuz yoğun görünüyor. Bitkisel uzmanlarımız altyapıyı kontrol ediyor, lütfen birkaç dakika sonra tekrar deneyiniz.',
    RATE_LIMIT:
      'Çok hızlı arama yaptınız. Doğal kürlerinizi hazırlayabilmemiz için lütfen bir dakika bekleyip tekrar deneyiniz.',
    GENERIC: 'Bağlantı sırasında bir sorun oluştu. Lütfen daha sonra tekrar deneyiniz.',
    CONFIG: 'Arama servisi şu anda yapılandırılmamış. Lütfen daha sonra tekrar deneyiniz.',
    PRODUCTS_LOAD: 'Ürün kartları yüklenirken bir sorun oluştu. Lütfen tekrar deneyiniz.',
    STOREFRONT: 'Mağaza verilerine ulaşılamadı. Lütfen birkaç dakika sonra tekrar deneyiniz.'
  };

  var STATES = {
    idle: 'idle',
    loading: 'loading',
    success: 'success',
    empty: 'empty',
    error: 'error'
  };

  var SESSION_KEY = 'zncbl-health-search-v2';
  /* Liquid all_products tek render'da en fazla 20 handle destekler */
  var LIQUID_HANDLES_BATCH_LIMIT = 20;

  var STOREFRONT_QUERY =
    'query ZencebylProductHandles($ids: [ID!]!) {' +
    '  nodes(ids: $ids) {' +
    '    ... on Product { id handle }' +
    '  }' +
    '}';

  var STOREFRONT_PRODUCT_BY_ID_QUERY =
    'query ZencebylProductById($id: ID!) {' +
    '  product(id: $id) { id handle }' +
    '}';

  function getConfig() {
    return window.ZencebylConfig || {};
  }

  function resolveRuntimeConfig(config) {
    var resolved = config || window.ZencebylConfig || getConfig() || {};
    if (!resolved.storefrontToken) {
      initConfig();
      resolved = window.ZencebylConfig || getConfig() || resolved;
    }
    return resolved || {};
  }

  function getResultsTarget() {
    return document.getElementById('ZencebylResultsTarget');
  }

  function getSectionRoot() {
    return document.querySelector('[data-zncbl-state]');
  }

  function getCorrelationId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'sh-' + window.crypto.randomUUID();
    }
    return 'sh-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function legacyResourceId(gid) {
    if (!gid || typeof gid !== 'string') return null;
    return gid.split('/').pop();
  }

  function toProductGid(productId) {
    if (productId == null || productId === '') return null;
    var id = String(productId).trim();
    if (!id) return null;
    if (id.indexOf('gid://shopify/Product/') === 0) return id;
    return 'gid://shopify/Product/' + id;
  }

  function buildRecommendationsUrl(baseUrl) {
    if (!baseUrl || typeof baseUrl !== 'string') return '';
    return baseUrl.replace(/\/+$/, '') + '/api/v1/recommendations/search';
  }

  function isApiSuccess(res) {
    if (!res || typeof res !== 'object') return false;
    if (res.isSuccess === true) return true;
    if (res.success === true) return true;
    if (res.errorCode === 0 || res.errorCode === '0') return true;
    return false;
  }

  function extractApiData(res) {
    var data = res && (res.data != null ? res.data : res.result);
    return data && typeof data === 'object' && !Array.isArray(data) ? data : {};
  }

  function extractRecommendations(res) {
    var data = extractApiData(res);
    if (Array.isArray(data.recommendations)) return data.recommendations;
    if (Array.isArray(data.records)) return data.records;
    if (Array.isArray(data.products)) return data.products;
    if (Array.isArray(res && res.data)) return res.data;
    return [];
  }

  function getRecommendationProductId(item) {
    if (!item) return null;
    if (item.productId != null && item.productId !== '') return item.productId;
    if (item.shopifyProductId != null && item.shopifyProductId !== '') return item.shopifyProductId;
    if (item.id != null && item.id !== '') return item.id;
    return null;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeParseJson(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function normalizeErrorCode(code) {
    if (code == null || code === '') return null;
    var numeric = Number(code);
    return Number.isNaN(numeric) ? code : numeric;
  }

  function isRawStatusMessage(message) {
    if (!message) return false;
    return /API yanıt kodu|Storefront API yanıt kodu|status\s*[:=]\s*\d{3}/i.test(message);
  }

  function resolveUserErrorMessage(options) {
    var httpStatus = options && options.httpStatus;
    var apiResult = options && options.apiResult;
    var fallback = (options && options.fallback) || ERROR_MESSAGES.GENERIC;
    var code = apiResult ? normalizeErrorCode(apiResult.errorCode) : null;

    if (httpStatus === 429) return ERROR_MESSAGES.RATE_LIMIT;
    if (code === 1000) return ERROR_MESSAGES.SYSTEM_BUSY;

    if (apiResult && apiResult.errorMessage) {
      var backendMessage = String(apiResult.errorMessage).trim();
      if (backendMessage && !isRawStatusMessage(backendMessage)) {
        return backendMessage;
      }
    }

    return fallback;
  }

  function createSearchError(message, correlationId) {
    var err = new Error(message);
    err.correlationId = correlationId || '';
    return err;
  }

  function getErrorPresentation(err, fallbackMessage) {
    var message = (err && err.message) || fallbackMessage || ERROR_MESSAGES.GENERIC;
    if (isRawStatusMessage(message)) {
      message = fallbackMessage || ERROR_MESSAGES.GENERIC;
    }
    return {
      message: message,
      correlationId: (err && err.correlationId) || ''
    };
  }

  function showSearchError(err, fallbackMessage) {
    var presentation = getErrorPresentation(err, fallbackMessage);
    renderError(presentation.message, presentation.correlationId);
    setStatus(presentation.message, true);
  }

  function setState(section, state) {
    if (!section) return;
    section.dataset.zncblState = state;
    section.classList.toggle('zncbl-health-search--loading', state === STATES.loading);
  }

  function setStatus(message, visible) {
    var el = document.getElementById('ZencebylStatus');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !visible;
  }

  function setSubmitLoading(isLoading) {
    var btn = document.getElementById('ZencebylSubmitBtn');
    if (!btn) return;
    btn.disabled = !!isLoading;
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    var spinner = btn.querySelector('.zncbl-health-search__submit-spinner');
    var label = btn.querySelector('.zncbl-health-search__submit-label');
    if (spinner) {
      if (isLoading) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }
    if (label) {
      if (isLoading) label.setAttribute('hidden', '');
      else label.removeAttribute('hidden');
    }
  }

  function saveSession(query, payload, state) {
    try {
      sessionStorage.setItem(
        SESSION_KEY,
        JSON.stringify({
          query: query,
          wellnessGoals: (payload && payload.wellnessGoals) || [],
          activeGoalKey: (payload && payload.activeGoalKey) || '',
          handles: (payload && payload.handles) || [],
          state: state || STATES.success,
          savedAt: Date.now()
        })
      );
    } catch (e) {
      /* sessionStorage dolu veya kapalı */
    }
  }

  function getCurrentQuery() {
    var input = document.getElementById('ZencebylQueryInput');
    var fromInput = input && input.value ? String(input.value).trim() : '';
    return fromInput || getQueryFromUrl();
  }

  function markActiveGoalCard(goalKey) {
    if (!goalKey) return;
    document.querySelectorAll('.zncbl-goal-card').forEach(function (el) {
      if (el.getAttribute('data-goal-key') === goalKey) {
        el.classList.add('zncbl-goal-card--active');
      } else {
        el.classList.remove('zncbl-goal-card--active');
      }
    });
  }

  function loadSession() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearSession() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function getQueryFromUrl() {
    try {
      return (new URLSearchParams(window.location.search).get('q') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function syncUrlQuery(query) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* ignore */
    }
  }

  /** Ürün detayından Geri veya tarayıcı geri/ileri — menüden yeni giriş değil */
  function shouldRestoreSession() {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') return true;

    var ref = document.referrer || '';
    if (ref.indexOf('/products/') !== -1) return true;

    return false;
  }

  /** quick-add-modal body'ye taşındığı için eski oturumları temizle */
  function removeOrphanedQuickAddModals() {
    document.querySelectorAll('quick-add-modal').forEach(function (modal) {
      modal.remove();
    });
  }

  function restoreSession() {
    var saved = loadSession();
    if (!saved || !saved.query) return Promise.resolve(false);

    var input = document.getElementById('ZencebylQueryInput');
    var section = getSectionRoot();
    var config = resolveRuntimeConfig(getConfig());
    var correlationId = getCorrelationId();
    var goals = Array.isArray(saved.wellnessGoals) ? saved.wellnessGoals : [];
    var handles = Array.isArray(saved.handles) ? saved.handles : [];

    if (!goals.length && !handles.length) {
      return Promise.resolve(false);
    }

    if (input) input.value = saved.query;
    syncUrlQuery(saved.query);

    removeOrphanedQuickAddModals();
    clearResults();
    setState(section, saved.state || STATES.success);

    if (goals.length) {
      renderWellnessGoals(goals, config, correlationId);
      markActiveGoalCard(saved.activeGoalKey || '');
    }

    if (!handles.length) {
      return Promise.resolve(true);
    }

    return renderProducts(handles, config).then(function () {
      var resultsTarget = getResultsTarget();
      if (resultsTarget) resultsTarget.hidden = false;
      return true;
    });
  }

  function resetSearchPage() {
    var input = document.getElementById('ZencebylQueryInput');
    var section = getSectionRoot();
    if (input) input.value = '';
    clearResults();
    setState(section, STATES.idle);
    setStatus('', false);
    syncUrlQuery('');
  }

  function clearResults() {
    var target = getResultsTarget();
    if (target) {
      target.innerHTML = '';
      target.hidden = false;
    }
    var goals = document.getElementById('ZencebylGoalsTarget');
    if (goals) {
      goals.innerHTML = '';
      goals.hidden = true;
    }
  }

  function getGoalIconSvg(key) {
    var common =
      ' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

    var icons = {
      /* Şimşek — enerji / mitokondri canlılığı */
      energy_boost:
        '<svg' +
        common +
        '>' +
        '<path d="M13.2 2.5L5.4 13.1h5.6L10.2 21.5l8.2-11.2h-5.4L13.2 2.5z"/>' +
        '</svg>',

      /* Kafa profili + sinir noktası — bilişsel */
      cognitive_performance:
        '<svg' +
        common +
        '>' +
        '<path d="M8.2 15.6c-2-.6-3.4-2.4-3.4-4.6 0-2.8 2.1-5.1 4.9-5.3.7-1.7 2.4-2.9 4.4-2.9 2.6 0 4.7 2 4.9 4.5 1.5.6 2.5 2 2.5 3.7 0 1.8-1.1 3.3-2.7 4"/>' +
        '<path d="M8.5 15.4c.4 1.7 1.9 3 3.7 3.2"/>' +
        '<circle cx="11.2" cy="10.8" r="1.15" fill="currentColor" stroke="none"/>' +
        '<path d="M13.2 11.2h2.6"/>' +
        '<path d="M14.4 9.2v4"/>' +
        '</svg>',

      /* Hilal + yıldız — uyku */
      sleep_quality:
        '<svg' +
        common +
        '>' +
        '<path d="M16.2 3.6A8 8 0 1 0 20 16.4 6.6 6.6 0 0 1 16.2 3.6z"/>' +
        '<path d="M17.8 6.4l.4.9.9.15-.7.65.2 1-.8-.5-.8.5.2-1-.7-.65.9-.15.4-.9z" fill="currentColor" stroke="none"/>' +
        '</svg>',

      /* Terazi — adrenal / stres dengesi */
      stress_adaptation:
        '<svg' +
        common +
        '>' +
        '<path d="M12 3.2v16.5"/>' +
        '<path d="M8.2 19.7h7.6"/>' +
        '<path d="M5.2 8.2h13.6"/>' +
        '<path d="M7.2 8.2l-2.4 5.2h4.8L7.2 8.2z"/>' +
        '<path d="M16.8 8.2l-2.4 5.2h4.8L16.8 8.2z"/>' +
        '<circle cx="12" cy="3.8" r="1.1" fill="currentColor" stroke="none"/>' +
        '</svg>',

      /* Yaprak — flora / sindirim */
      digestive_comfort:
        '<svg' +
        common +
        '>' +
        '<path d="M12 20.4c4.6-1.4 7.6-5.4 7.8-11.2C14.4 9 10.8 12.2 9.2 16.2"/>' +
        '<path d="M12 20.4C7.4 19 4.4 15 4.2 9.2 9.6 9.4 13.2 12.6 14.8 16.6"/>' +
        '<path d="M12 20.4V10.2"/>' +
        '</svg>',

      /* Çoklu ışıltı — cilt / nutricosmetic */
      skin_elasticity:
        '<svg' +
        common +
        '>' +
        '<path d="M12 4.2v3.2M12 16.6v3.2M4.2 12h3.2M16.6 12h3.2"/>' +
        '<path d="M6.8 6.8l2.2 2.2M15 15l2.2 2.2M17.2 6.8l-2.2 2.2M9 15l-2.2 2.2"/>' +
        '<circle cx="12" cy="12" r="2.4"/>' +
        '</svg>',

      /* Kemik eklem — hareket */
      joint_mobility:
        '<svg' +
        common +
        '>' +
        '<path d="M6.2 7.4c0-1.8 1.4-3.2 3.2-3.2h1.1c1.1 0 2 .9 2 2v2.8c0 1.1-.9 2-2 2H9.4c-1.8 0-3.2-1.4-3.2-3.2v-.4z"/>' +
        '<path d="M11.6 13c0-1.1.9-2 2-2h1.1c1.8 0 3.2 1.4 3.2 3.2v.4c0 1.8-1.4 3.2-3.2 3.2h-1.1c-1.1 0-2-.9-2-2V13z"/>' +
        '<path d="M12.5 10.8l-1 1.4"/>' +
        '<path d="M4.8 9.8h2.2M17 14.2h2.2"/>' +
        '</svg>',

      /* Kalkan + artı — bağışıklık */
      immune_defense:
        '<svg' +
        common +
        '>' +
        '<path d="M12 2.8l7.5 2.9v5.4c0 4.9-3.3 8.5-7.5 9.9-4.2-1.4-7.5-5-7.5-9.9V5.7L12 2.8z"/>' +
        '<path d="M12 8.4v6.2"/>' +
        '<path d="M8.9 11.5h6.2"/>' +
        '</svg>'
    };

    var fallback =
      '<svg' +
      common +
      '>' +
      '<circle cx="12" cy="12" r="8"/>' +
      '<path d="M12 8.2v4.2"/>' +
      '<circle cx="12" cy="15.6" r="0.95" fill="currentColor" stroke="none"/>' +
      '</svg>';

    return icons[key] || fallback;
  }

  function renderWellnessGoals(wellnessGoals, config, correlationId) {
    var goalsTarget = document.getElementById('ZencebylGoalsTarget');
    var resultsTarget = getResultsTarget();
    if (!goalsTarget) return;

    goalsTarget.className = 'zncbl-goals-panel';
    goalsTarget.innerHTML = '';
    goalsTarget.hidden = false;
    if (resultsTarget) resultsTarget.hidden = true;

    if (!Array.isArray(wellnessGoals) || !wellnessGoals.length) return;

    config = resolveRuntimeConfig(config);
    correlationId = correlationId || getCorrelationId();

    var intro = document.createElement('div');
    intro.className = 'zncbl-goals-panel__intro';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'zncbl-goals-panel__eyebrow';
    eyebrow.textContent = 'Kişisel protokol';

    var heading = document.createElement('h2');
    heading.className = 'zncbl-goals-panel__heading';
    heading.textContent = 'Sana en uygun odak alanını seç';

    var sub = document.createElement('p');
    sub.className = 'zncbl-goals-panel__sub';
    sub.textContent =
      'Her kart, bir wellness hedefini temsil eder. Seçimini yaptığında ürünler koleksiyon düzeninde listelenir.';

    intro.appendChild(eyebrow);
    intro.appendChild(heading);
    intro.appendChild(sub);

    var grid = document.createElement('div');
    grid.className = 'zncbl-goals-grid';

    wellnessGoals.forEach(function (goal) {
      if (!goal || typeof goal !== 'object') return;

      var productIds = Array.isArray(goal.associatedProductIds)
        ? goal.associatedProductIds
        : [];
      var key = goal.key != null ? String(goal.key) : '';
      var displayName = goal.displayName != null ? String(goal.displayName) : '';
      var description = goal.description != null ? String(goal.description) : '';

      var card = document.createElement('div');
      card.className = 'zncbl-goal-card';
      card.setAttribute('data-goal-key', key);
      card.setAttribute('data-product-ids', JSON.stringify(productIds));
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');

      var iconWrap = document.createElement('div');
      iconWrap.className = 'zncbl-goal-card__icon';
      iconWrap.innerHTML = getGoalIconSvg(key);

      var textWrap = document.createElement('div');
      textWrap.className = 'zncbl-goal-card__text-wrap';

      var title = document.createElement('h3');
      title.className = 'zncbl-goal-card__title';
      title.textContent = displayName;

      var desc = document.createElement('p');
      desc.className = 'zncbl-goal-card__desc';
      desc.textContent = description;

      textWrap.appendChild(title);
      textWrap.appendChild(desc);

      var cta = document.createElement('span');
      cta.className = 'zncbl-goal-card__cta';
      cta.textContent = 'Ürünleri incele';

      card.appendChild(iconWrap);
      card.appendChild(textWrap);
      card.appendChild(cta);

      card.addEventListener('click', function () {
        handleGoalCardSelect(card, productIds, config, correlationId);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleGoalCardSelect(card, productIds, config, correlationId);
        }
      });

      grid.appendChild(card);
    });

    goalsTarget.appendChild(intro);
    goalsTarget.appendChild(grid);
  }

  function parseProductIdsFromCard(card) {
    if (!card) return [];
    var raw = card.getAttribute('data-product-ids');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function resolveHandlesFromProductIds(productIds, nodes) {
    var handleMap = Object.create(null);
    (nodes || []).forEach(function (node) {
      if (node && node.id && node.handle) {
        handleMap[node.id.split('/').pop()] = node.handle;
      }
    });
    return (productIds || [])
      .map(function (id) {
        var raw = String(id).trim();
        if (!raw) return null;
        if (handleMap[raw]) return handleMap[raw];
        var numeric = raw.indexOf('/') !== -1 ? raw.split('/').pop() : raw;
        return handleMap[numeric];
      })
      .filter(Boolean);
  }

  function handleGoalCardSelect(card, productIds, config, correlationId) {
    document.querySelectorAll('.zncbl-goal-card').forEach(function (el) {
      el.classList.remove('zncbl-goal-card--active');
    });
    if (card) card.classList.add('zncbl-goal-card--active');

    var ids = Array.isArray(productIds) && productIds.length
      ? productIds
      : parseProductIdsFromCard(card);

    var gids = ids
      .map(function (id) {
        return toProductGid(id);
      })
      .filter(Boolean);

    var resultsTarget = getResultsTarget();
    if (resultsTarget) {
      resultsTarget.hidden = false;
      renderLoadingInTarget();
    }

    if (!gids.length) {
      renderNoResults();
      return Promise.resolve();
    }

    config = resolveRuntimeConfig(config || window.ZencebylConfig || getConfig());
    correlationId = correlationId || getCorrelationId();

    return fetchStorefrontHandles(gids, config, correlationId)
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          throw createSearchError(ERROR_MESSAGES.STOREFRONT, correlationId);
        }

        var nodes =
          payload.data && Array.isArray(payload.data.nodes) ? payload.data.nodes : [];
        var handles = resolveHandlesFromProductIds(ids, nodes);

        if (!handles.length) {
          renderNoResults();
          return;
        }

        return renderProducts(handles, config || window.ZencebylConfig).then(function () {
          var query = getCurrentQuery();
          var goalKey = card ? card.getAttribute('data-goal-key') || '' : '';
          var existing = loadSession() || {};
          persistSearchResults(
            query,
            handles,
            existing.wellnessGoals || [],
            goalKey
          );

          var target = document.getElementById('ZencebylResultsTarget');
          if (target && typeof target.scrollIntoView === 'function') {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      })
      .catch(function (err) {
        showSearchError(err, ERROR_MESSAGES.GENERIC);
      });
  }

  function renderLoadingInTarget() {
    var target = getResultsTarget();
    if (!target) return;
    target.innerHTML =
      '<div class="zncbl-loading" role="status" aria-live="polite">' +
      '<span class="zncbl-loading__spinner" aria-hidden="true"></span>' +
      '<span class="zncbl-loading__text">' + escapeHtml(LOADING_MESSAGE) + '</span>' +
      '</div>';
  }

  function renderNoResults() {
    var target = getResultsTarget();
    if (!target) return;
    target.innerHTML = '<p class="zncbl-no-results">' + escapeHtml(EMPTY_MESSAGE) + '</p>';
  }

  function renderError(message, correlationId) {
    var target = getResultsTarget();
    if (!target) return;
    var html =
      '<div class="zncbl-health-search__error" role="alert">' +
      '<p class="zncbl-health-search__error-message">' +
      escapeHtml(message || ERROR_MESSAGES.GENERIC) +
      '</p>';
    if (correlationId) {
      html +=
        '<p class="zncbl-health-search__error-support">Destek Kodu: ' +
        escapeHtml(correlationId) +
        '</p>';
    }
    html += '</div>';
    target.innerHTML = html;
  }

  function collectStorefrontIds(recommendations) {
    var ids = [];
    if (!Array.isArray(recommendations)) return ids;
    recommendations.forEach(function (item) {
      var gid = toProductGid(getRecommendationProductId(item));
      if (gid) ids.push(gid);
    });
    return ids;
  }

  function buildHandleMapFromNodes(nodes) {
    var handleById = Object.create(null);
    if (!Array.isArray(nodes)) return handleById;
    nodes.forEach(function (node) {
      if (node && node.id && node.handle) {
        handleById[legacyResourceId(node.id)] = node.handle;
      }
    });
    return handleById;
  }

  function buildHandleOrderFromMap(recommendations, handleById) {
    var handles = [];
    if (!Array.isArray(recommendations) || !handleById) return handles;
    recommendations.forEach(function (item) {
      var gid = toProductGid(getRecommendationProductId(item));
      var id = legacyResourceId(gid);
      if (id && handleById[id]) handles.push(handleById[id]);
    });
    return handles;
  }

  function fetchStorefrontProductById(gid, config, correlationId) {
    if (!gid || !config.storefrontToken || !config.storefrontUrl) {
      return Promise.resolve(null);
    }
    return fetch(config.storefrontUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontToken
      },
      body: JSON.stringify({
        query: STOREFRONT_PRODUCT_BY_ID_QUERY,
        variables: { id: gid }
      })
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var body = safeParseJson(text);
          if (!res.ok || !body || !body.data) return null;
          return body.data.product || null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function enrichHandleOrder(recommendations, nodes, config, correlationId) {
    var handleById = buildHandleMapFromNodes(nodes);
    var missingGids = [];

    recommendations.forEach(function (item) {
      var gid = toProductGid(getRecommendationProductId(item));
      var id = legacyResourceId(gid);
      if (id && !handleById[id] && gid) missingGids.push(gid);
    });

    if (!missingGids.length) {
      return Promise.resolve(buildHandleOrderFromMap(recommendations, handleById));
    }

    return Promise.all(
      missingGids.map(function (gid) {
        return fetchStorefrontProductById(gid, config, correlationId);
      })
    ).then(function (products) {
      products.forEach(function (product) {
        if (product && product.id && product.handle) {
          handleById[legacyResourceId(product.id)] = product.handle;
        }
      });
      return buildHandleOrderFromMap(recommendations, handleById);
    });
  }

  function fetchRecommendations(query, config, correlationId) {
    var url = buildRecommendationsUrl(config.healthApiUrl);
    if (!url || !config.healthApiKey) {
      return Promise.reject(createSearchError(ERROR_MESSAGES.CONFIG, correlationId));
    }
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': config.healthApiKey,
        'X-Correlation-ID': correlationId
      },
      body: JSON.stringify({ userMessage: query })
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = safeParseJson(text);

        if (!res.ok || !isApiSuccess(body)) {
          throw createSearchError(
            resolveUserErrorMessage({
              httpStatus: res.status,
              apiResult: body,
              fallback: ERROR_MESSAGES.GENERIC
            }),
            correlationId
          );
        }

        return body;
      });
    });
  }

  function fetchStorefrontHandles(ids, config, correlationId) {
    if (!config.storefrontToken || !config.storefrontUrl) {
      return Promise.reject(createSearchError(ERROR_MESSAGES.CONFIG, correlationId));
    }
    return fetch(config.storefrontUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontToken
      },
      body: JSON.stringify({ query: STOREFRONT_QUERY, variables: { ids: ids } })
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = safeParseJson(text);

        if (!res.ok) {
          throw createSearchError(
            resolveUserErrorMessage({
              httpStatus: res.status,
              apiResult: body,
              fallback: ERROR_MESSAGES.STOREFRONT
            }),
            correlationId
          );
        }

        return body || {};
      });
    });
  }

  function parseProductGridSectionHtml(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var container = parsed.getElementById('ZencebylProductGridContainer');
    if (container) return container.innerHTML;
    var sectionEl = parsed.querySelector('[id*="health-search-product-grid"]');
    return sectionEl ? sectionEl.innerHTML : html;
  }

  function buildSearchQuery(handles) {
    return handles
      .map(function (handle) {
        return 'handle:' + handle;
      })
      .join(' OR ');
  }

  function countGridItemsInSectionHtml(gridHtml) {
    return getRenderedHandlesFromGridHtml(gridHtml).length;
  }

  function chunkArray(items, size) {
    var chunks = [];
    if (!Array.isArray(items) || !items.length) return chunks;
    for (var i = 0; i < items.length; i += size) {
      chunks.push(items.slice(i, i + size));
    }
    return chunks;
  }

  function getRenderedHandlesFromGridHtml(gridHtml) {
    if (!gridHtml || gridHtml.indexOf('grid-item') === -1) return [];
    var parsed = new DOMParser().parseFromString(
      '<div id="ZencebylProductGridContainer">' + gridHtml + '</div>',
      'text/html'
    );
    return Array.prototype.map
      .call(parsed.querySelectorAll('#zncbl-product-grid .grid-item'), function (li) {
        return li.getAttribute('data-zncbl-handle');
      })
      .filter(function (handle) {
        return handle && handle.length > 0;
      });
  }

  function extractGridItemOuterHtmlList(gridHtml) {
    if (!gridHtml) return [];
    var parsed = new DOMParser().parseFromString(
      '<div id="ZencebylProductGridContainer">' + gridHtml + '</div>',
      'text/html'
    );
    return Array.prototype.map.call(
      parsed.querySelectorAll('#zncbl-product-grid .grid-item'),
      function (li) {
        return li.outerHTML;
      }
    );
  }

  function assembleGridHtml(itemOuterHtmlList, templateGridHtml) {
    if (!itemOuterHtmlList.length) return '';
    var parsed = new DOMParser().parseFromString(
      '<div id="ZencebylProductGridContainer">' + (templateGridHtml || '') + '</div>',
      'text/html'
    );
    var ul = parsed.querySelector('#zncbl-product-grid');
    if (!ul) return templateGridHtml || '';
    ul.innerHTML = itemOuterHtmlList.join('');
    var container = parsed.getElementById('ZencebylProductGridContainer');
    return container ? container.innerHTML : '';
  }

  function mergeGridHtmlParts(htmlParts) {
    var allItems = [];
    var template = '';

    htmlParts.forEach(function (part) {
      if (!part) return;
      if (!template && part.indexOf('zncbl-product-grid') !== -1) template = part;
      allItems = allItems.concat(extractGridItemOuterHtmlList(part));
    });

    var seen = Object.create(null);
    var uniqueItems = [];
    allItems.forEach(function (outerHtml) {
      var doc = new DOMParser().parseFromString(outerHtml, 'text/html');
      var li = doc.body.firstElementChild;
      var handle = li && li.getAttribute('data-zncbl-handle');
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      uniqueItems.push(outerHtml);
    });

    return assembleGridHtml(uniqueItems, template || htmlParts[0] || '');
  }

  function loadProductGridSection(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (res) {
      if (!res.ok) {
        throw createSearchError(
          resolveUserErrorMessage({
            httpStatus: res.status,
            apiResult: null,
            fallback: ERROR_MESSAGES.PRODUCTS_LOAD
          }),
          ''
        );
      }
      return res.text();
    });
  }

  function fetchHandlesGridBatch(handles, config) {
    if (!handles.length) return Promise.resolve('');
    return loadProductGridSection(buildHandlesGridUrl(handles, config)).then(parseProductGridSectionHtml);
  }

  function fetchSearchGridBatch(handles, config) {
    if (!handles.length) return Promise.resolve('');
    return loadProductGridSection(buildSearchGridUrl(handles, config)).then(parseProductGridSectionHtml);
  }

  function recoverMissingHandleGrids(missingHandles, config) {
    if (!missingHandles.length) return Promise.resolve([]);
    return Promise.all(
      missingHandles.map(function (handle) {
        return fetchHandlesGridBatch([handle], config).then(function (html) {
          if (countGridItemsInSectionHtml(html) > 0) return html;
          return fetchSearchGridBatch([handle], config);
        });
      })
    );
  }

  function buildHandlesGridUrl(handles, config) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionId = config.gridSectionId || 'health-search-product-grid';
    return (
      root.replace(/\/?$/, '/') +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&handles=' +
      encodeURIComponent(handles.join(','))
    );
  }

  function buildSearchGridUrl(handles, config) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionId = config.gridSectionId || 'health-search-product-grid';
    var searchBase = root.replace(/\/?$/, '/') + 'search';
    return (
      searchBase +
      '?type=product&q=' +
      encodeURIComponent(buildSearchQuery(handles)) +
      '&section_id=' +
      encodeURIComponent(sectionId)
    );
  }

  /**
   * Handles listesini batch'ler halinde Section Rendering API ile yükler.
   * Shopify search (10 limit) ve all_products (20 limit) kısıtlarını aşmak için
   * merge + recoverMissingHandleGrids kullanır. Sıra: reorderGridByHandles ile korunur.
   */
  function fetchProductGridHtml(handles, config) {
    var chunks = chunkArray(handles, LIQUID_HANDLES_BATCH_LIMIT);

    return Promise.all(
      chunks.map(function (chunk) {
        return fetchHandlesGridBatch(chunk, config);
      })
    ).then(function (batchParts) {
      var merged = mergeGridHtmlParts(batchParts);
      var rendered = getRenderedHandlesFromGridHtml(merged);
      var missing = handles.filter(function (handle) {
        return rendered.indexOf(handle) === -1;
      });

      if (!missing.length) return merged;

      return recoverMissingHandleGrids(missing, config).then(function (recoveryParts) {
        return mergeGridHtmlParts(batchParts.concat(recoveryParts));
      });
    });
  }

  function reorderGridByHandles(container, handles) {
    var ul = container.querySelector('#zncbl-product-grid');
    if (!ul) return;
    handles.forEach(function (handle) {
      var item = ul.querySelector('[data-zncbl-handle="' + handle + '"]');
      if (item) ul.appendChild(item);
    });
  }

  function initGridEnhancements(container) {
    if (typeof AOS !== 'undefined' && AOS.refreshHard) {
      AOS.refreshHard();
    } else if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }

  function renderProducts(handles, config) {
    var target = document.getElementById('ZencebylResultsTarget');
    if (!target) return Promise.resolve();

    removeOrphanedQuickAddModals();

    return fetchProductGridHtml(handles, config).then(function (gridHtml) {
      if (!gridHtml || !gridHtml.trim() || gridHtml.indexOf('grid-item') === -1) {
        renderNoResults();
        return;
      }

      target.hidden = false;
      target.innerHTML = gridHtml;
      reorderGridByHandles(target, handles);
      initGridEnhancements(target);
    });
  }

  function persistSearchResults(query, handles, wellnessGoals, activeGoalKey) {
    var section = getSectionRoot();
    if (!query) return;
    var existing = loadSession() || {};
    var state = section ? section.dataset.zncblState : STATES.success;
    saveSession(
      query,
      {
        wellnessGoals: wellnessGoals || existing.wellnessGoals || [],
        activeGoalKey: activeGoalKey != null ? activeGoalKey : existing.activeGoalKey || '',
        handles: handles || []
      },
      state
    );
    syncUrlQuery(query);
  }

  function runSearch(query) {
    var config = resolveRuntimeConfig(getConfig());
    var section = getSectionRoot();

    if (!config.healthApiUrl || !config.healthApiKey) {
      showSearchError(createSearchError(ERROR_MESSAGES.CONFIG, ''), ERROR_MESSAGES.CONFIG);
      return Promise.resolve();
    }

    var correlationId = getCorrelationId();
    clearResults();
    setStatus('', false);
    setState(section, STATES.loading);
    setSubmitLoading(true);
    renderLoadingInTarget();

    return fetchRecommendations(query, config, correlationId)
      .then(function (res) {
        var wellnessGoals =
          res && res.data && Array.isArray(res.data.wellnessGoals) ? res.data.wellnessGoals : [];

        if (!wellnessGoals.length) {
          setState(section, STATES.empty);
          renderNoResults();
          saveSession(query, { wellnessGoals: [], handles: [], activeGoalKey: '' }, STATES.empty);
          syncUrlQuery(query);
          return null;
        }

        renderWellnessGoals(res.data.wellnessGoals, config, correlationId);
        setState(section, STATES.success);
        saveSession(
          query,
          {
            wellnessGoals: res.data.wellnessGoals,
            handles: [],
            activeGoalKey: ''
          },
          STATES.success
        );
        syncUrlQuery(query);
        setSubmitLoading(false);
        return null;
      })
      .catch(function (err) {
        setState(section, STATES.error);
        showSearchError(err, ERROR_MESSAGES.GENERIC);
      })
      .finally(function () {
        setSubmitLoading(false);
        if (section && section.dataset.zncblState === STATES.loading) {
          setState(section, STATES.idle);
        }
      });
  }

  function handleSearchSubmit(event) {
    event.preventDefault();
    var query = (document.getElementById('ZencebylQueryInput') || {}).value;
    query = query ? query.trim() : '';

    if (!query) {
      setStatus('Lütfen bir arama sorgusu girin.', true);
      return;
    }

    runSearch(query);
  }

  function bootstrap() {
    initConfig();
    setSubmitLoading(false);

    var form = document.getElementById('ZencebylSearchForm');
    if (form) form.addEventListener('submit', handleSearchSubmit);

    if (shouldRestoreSession()) {
      restoreSession().then(function (restored) {
        if (!restored) {
          var saved = loadSession();
          var q = (saved && saved.query) || getQueryFromUrl();
          if (q) runSearch(q);
        }
      });
      return;
    }

    clearSession();
    resetSearchPage();

    var urlQuery = getQueryFromUrl();
    if (urlQuery) {
      var input = document.getElementById('ZencebylQueryInput');
      if (input) input.value = urlQuery;
      runSearch(urlQuery);
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (!document.getElementById('ZencebylSearchSection')) return;
    setSubmitLoading(false);
    /* bfcache: sayfa zaten canlı DOM ile gelir, HTML enjekte etme */
    if (event.persisted) return;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
